export const styles = {
  wrapper: (open: boolean) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: 'solid 1px #F3F4F9',
    borderRadius: '8px',
    maxHeight: '36px',
    ...(open && {
      boxShadow: '0px 0px 2px #4D6EF5',
    }),
    '&:hover': {
      boxShadow: '0px 0px 2px #4D6EF5',
    },
  }),
  button: {
    display: 'flex',
    justifyContent: 'flex-start',
    textTransform: 'none',
    color: 'black',
    border: 'unset',
    padding: '8px 12px 8px 8px',
    minWidth: 'auto',
    maxHeight: '36px',

    '&:hover': {
      border: 'none',
    },

    '& .MuiButton-startIcon': {
      marginRight: '12px',
      marginLeft: '0px',

      '& svg, img': {
        width: '20px',
        height: '20px',
        borderRadius: '8px',
      },
    },
  },
  title: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20.44px',
    alignItems: 'start',
    textAlign: 'right',
    color: '#23252F',
    maxWidth: '117px',
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: '1',
    WebkitBoxOrient: 'vertical',
    wordBreak: 'keep-all',
  },
  popover: {
    '& .MuiPopover-paper': {
      padding: '0 !important',
    },
  },
  paper: {
    marginTop: '8px',
    width: '450px',
    background: '#FFFFFF',
    border: '1px solid #F3F4F9',
    boxShadow: '0px 4px 10px rgba(35, 37, 47, 0.1), 1px 2px 2px rgba(35, 37, 47, 0.04)',
    borderRadius: '12px',
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%',
  },
};
